/** Палитра этапов (как в графике строительства / StageAutocomplete). */
export const STAGE_COLORS = [
  { bg: '#e3f2fd', border: '#2196f3', text: '#1565c0' },
  { bg: '#e8f5e9', border: '#4caf50', text: '#2e7d32' },
  { bg: '#fff3e0', border: '#ff9800', text: '#e65100' },
  { bg: '#f3e5f5', border: '#9c27b0', text: '#6a1b9a' },
  { bg: '#e0f7fa', border: '#00bcd4', text: '#00838f' },
  { bg: '#fce4ec', border: '#e91e63', text: '#c2185b' },
  { bg: '#fff8e1', border: '#ffc107', text: '#ff8f00' },
  { bg: '#e8eaf6', border: '#3f51b5', text: '#283593' },
  { bg: '#efebe9', border: '#795548', text: '#4e342e' },
  { bg: '#eceff1', border: '#607d8b', text: '#37474f' },
];

export const getStageColor = (index) => STAGE_COLORS[((index % STAGE_COLORS.length) + STAGE_COLORS.length) % STAGE_COLORS.length];

export const hexToRgba = (hex, alpha) => {
  if (!hex || !hex.startsWith('#') || hex.length < 7) return `rgba(0, 0, 0, ${alpha})`;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
